import * as React from 'react';
import { LabelBox } from '../../components/LabelBox';
import { useLabels } from './hooks/useLabels';

interface ILabelsContainerProps {
  builderId: number;
}

export const LabelsContainer: React.FC<ILabelsContainerProps> = ({ builderId }) => {
  const labels = useLabels(builderId);

  if (!labels.length) {
    return null;
  }

  return (
    <>
      {labels.map(labelProps => (
        <LabelBox {...labelProps} key={labelProps.key} />
      ))}
    </>
  );
};
